module.exports = "<main>\n    <div class=\"loginPageHeader\">\n        Login\n    </div>\n    <form class=\"loginPageFormContainer\">\n        <!-- Username:<br> -->\n        <input type=\"text\" placeholder=\"Username\" name=\"username\">\n        <br/>\n        <!-- Password:<br> -->\n        <input type=\"text\" placeholder=\"Password\" name=\"password\">\n        <br/>\n        <input type=\"submit\" value=\"Submit\">\n    </form>\n</main>"


//////////////////
// WEBPACK FOOTER
// /home/ppeters/filmCritClient/src/app/components/loginPage/loginPage.component.html
// module id = ../../../../../src/app/components/loginPage/loginPage.component.html
// module chunks = main